import React from 'react';
import propTypes from 'prop-types';
import { Alert } from 'antd';

import style from './index.less';

function Title({ hasMargin = false, title = '', message = '', right = null, className = '' }) {

  return (
    <div className={`${style.title} ${className} ${hasMargin ? style.margin : ''}`}>
      <div className={style.title_text}>{title}</div>
      {message ? (
        <div className={style.right}>
          <Alert message={message} showIcon type="info" />
        </div>
      ) : null}
      {right ? <div className={`${style.right} ${style.right_element}`}>{right}</div> : null}
    </div>
  );
}

Title.propTypes = {
  hasMargin: propTypes.bool,
  message: propTypes.string,
  title: propTypes.string,
  right: propTypes.element,
  className: propTypes.string
};

export default Title;
